import gql from "graphql-tag";

export default gql`
  mutation QueryRefreshAuthToken {
    refreshAuthToken {
      token
    }
  }
`;
